import { selectCompanyId } from "modules/company/redux/selectors";
import { selectCurrentTheaterId } from "modules/theater/selectors";
import { useSelector } from "react-redux";
import { getDoc } from "firebase/firestore";
import { sendPostRequest } from "services/apiService";
import { selectCurrentEventId } from "modules/event/selectors";
import { useAppDispatch } from "store/hooks";
import { selectUserId } from "modules/auth/redux/selectors";
import { showInitShuffleBanner } from "../../redux/actions";
import {
  IShuffleAttendeesDoc,
  useShuffleAttendees,
} from "../useShuffleAttendees";

export const useStartShuffle = () => {
  const userId = useSelector(selectUserId);
  const companyId = useSelector(selectCompanyId);
  const theaterId = useSelector(selectCurrentTheaterId);
  const eventId = useSelector(selectCurrentEventId);
  const { getShuffleAttendeesDoc } = useShuffleAttendees();
  const dispatch = useAppDispatch();

  const startShuffle = async () => {
    if (eventId) {
      const shuffleDoc = await getDoc(getShuffleAttendeesDoc(eventId));
      const data = shuffleDoc.data() as IShuffleAttendeesDoc;

      if (data.initiatedBy === userId) {
        dispatch(showInitShuffleBanner());
        await sendPostRequest(`/event/${eventId}/shuffle`, {
          theaterId,
          eventId,
          companyId,
          targetGroupSize: data.targetGroupSize,
        });
      }
    }
  };

  return {
    startShuffle,
  };
};
